import { useEffect, useState } from "react";
import { getPatientList } from "../services/dentalArchService";
import type { PatientListItem } from "../types/dental";

interface UsePatientListResult {
  data: PatientListItem[];
  isLoading: boolean;
  error: string | null;
}

export function usePatientList(): UsePatientListResult {
  const [data, setData] = useState<PatientListItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function load(): Promise<void> {
      try {
        setIsLoading(true);
        setError(null);
        const result = await getPatientList();

        if (isMounted) {
          setData(result);
        }
      } catch (err) {
        if (isMounted) {
          setError(err instanceof Error ? err.message : "Unknown error");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, isLoading, error };
}